var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"marry-state",class:[_vm.marry ? 'marry' : '', _vm.size],domProps:{"innerHTML":_vm._s(_vm.stateText())}})}
var staticRenderFns = []

export { render, staticRenderFns }